import Users from "entities/Users";
import { useState } from "react";
import View from "./View";

const List = () => {
  const [pagination, setPagination] = useState({});
  const filter = { where: {}, orderBy: [{ createdDate: "desc" }] };

  return (
    <Users
      View={View}
      filter={{ ...filter, ...pagination }}
      setValues={setPagination}
      skip={pagination.skip || 0}
    />
  );
};

export default List;
